import axios from "axios";

export function getRegistrationsForUser(userId) {
  return axios.get(process.env.REACT_APP_API + "/registrations?userId=" + userId);
}

export function saveRegistration(registration) {
  return axios.post(process.env.REACT_APP_API + "/registrations", registration).then((response) => response.data);
}

export function updateRegistrationIdentificationStatus(registrationId, identificationStatus) {
  return axios
    .put(
      process.env.REACT_APP_API + "/registrations/" + registrationId + "/identificationStatus/" + identificationStatus
    )
    .then((response) => response.data);
}

export function updateRegistrationFeeStatus(registrationId, feeStatus) {
  return axios
    .put(process.env.REACT_APP_API + "/registrations/" + registrationId + "/feeStatus/" + feeStatus)
    .then((response) => response.data);
}

export function loadRegistrationFromFriendlyId(friendlyId) {
  return axios
    .get(process.env.REACT_APP_API + "/registrations/userFriendlyId/" + friendlyId)
    .then((response) => response.data);
}

export function searchRegistrations(registrationSearchRequest) {
  return axios
    .get(process.env.REACT_APP_API + "/admin/registrations/search", {
      params: new URLSearchParams(registrationSearchRequest),
    })
    .then((response) => response.data);
}

export function updateAdoptionDetails(registrationId, adoptionDetails) {
  return axios
    .put(process.env.REACT_APP_API + "/admin/registrations/updateAdoptionDetails/" + registrationId, adoptionDetails)
    .then((response) => response.data);
}

export function updateRegistrationSearched(registrationId) {
  return axios
    .put(process.env.REACT_APP_API + "/admin/registrations/" + registrationId + "/searchComplete")
    .then((response) => response.data);
}

export function inactivateRegistration(registrationId) {
  return axios
    .put(process.env.REACT_APP_API + "/admin/registrations/" + registrationId + "/inactivate")
    .then((response) => response.data);
}

export function activateRegistration(registrationId) {
  return axios
    .put(process.env.REACT_APP_API + "/admin/registrations/" + registrationId + "/activate")
    .then((response) => response.data);
}
